import { WebActionNames } from "../constants/webActionNames";
import { WebControllers } from "../constants/webControllers";
import { FeedbackType } from "../store/feedbackType";
import { get } from "../common/dataFetch";

export const readCollectionAsync = () => get<FeedbackType[]>(WebControllers.FeedbackType, WebActionNames.ReadNoParamsAsync);
